module.exports = __webpack_public_path__ + "img/BL_lab_bar_logo.3f3712c2.svg";